import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EnergyUnit } from '../api/types';

const useEnergyUnitOptions = () => {
    const { t } = useTranslation('common');

    return useMemo(() => {
        const energyUnitOptions = [
            {
                value: EnergyUnit.Liters,
                label: t('common:options.energyUnit.liters'),
            },
            {
                value: EnergyUnit.Kwh,
                label: t('common:options.energyUnit.kwh'),
            },
        ];

        return energyUnitOptions;
    }, [t]);
};

export default useEnergyUnitOptions;
